#version 300 es
precision highp float;

flat in vec3 vColor;
in float vAlpha;
out vec4 fragColor;

float character(int n, vec2 p) {
  p = floor(p * vec2(-4.0, 4.0) + 2.5);
  if(clamp(p.x, 0.0, 4.0) == p.x && clamp(p.y, 0.0, 4.0) == p.y) {
    int a = int(round(p.x) + 5.0 * round(p.y));
    if(((n >> a) & 1) == 1) return 1.0;
  }
  return 0.0;
}

void main() {
  vec3 col = vColor;
  float gray = 0.3 * col.r + 0.59 * col.g + 0.11 * col.b;
  int n = 4096;

  if (gray > 0.2) n = 65600;
  if (gray > 0.3) n = 163153;
  if (gray > 0.4) n = 15255086;
  if (gray > 0.5) n = 13121101;
  if (gray > 0.6) n = 15252014;
  if (gray > 0.7) n = 13195790;
  if (gray > 0.8) n = 11512810;

  // gl_PointCoord has its origin top-left; the glyph expects bottom-left pixels
  vec2 p = vec2(gl_PointCoord.x, 1.0 - gl_PointCoord.y) * 2.0 - 1.0;
  float c = character(n, p);
  if (c == 0.0) discard;

  fragColor = vec4(col * vAlpha, 1.0);
}
